<script>
import styleHOCFactory from './utils';
export default styleHOCFactory('arrow', ['vertical', 'small']);
</script>

<style module>
@import "styles/variables.css";

._arrow-style {
  composes: relative b--green from global;
  border-width: 2px 0 0 0;
  border-style: solid;
  transition: background-color 0.25s ease-in-out;
  fill: var(--green);
  width: 9rem;
  &:hover {
    background-color: var(--green);
    fill: black;
  }
  &:global(.-vertical) {
    width: initial;
    border-width: 0 0 0 2px;
  }
  &:global(.-vertical .icon) {
    transform: rotate(-90deg);
  }
  &:global(.-small .icon) {
    width: 1.2rem;
  }
}
</style>
